// @flow
import React from "react";

export default ({ isActive }) => {
  const fillColor = isActive ? "#3b9478" : "#5D6067";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <g>
        <g>
          <g>
            <path
              d="M11.545,9.507a2.839,2.839,0,0,1,2.806-2.871,2.414,2.414,0,0,1,.759.107.154.154,0,0,0,.222-.122,4.66,4.66,0,0,0,.158-1.181c0-.027-.015-3.415-.015-3.457,0-.334-.187-.333-.271-.333a6.212,6.212,0,0,1-1.854-.186C12.015,1.07,10.827,0,10.376,0S9.057,1.07,7.721,1.464a6.284,6.284,0,0,1-2.151.149c-.079,0-.206-.025-.246.256-.01.071-.062,3.533-.062,3.571C5.262,8.823,9.352,12,10.376,12a3.252,3.252,0,0,0,1.565-.81c.095-.084.044-.139.016-.186A2.905,2.905,0,0,1,11.545,9.507Z"
              transform="translate(-5.262)"
              fill={fillColor}
            />
            <path
              d="M185.564,205.017a.285.285,0,0,1-.375.036l-1.777-1.344a.26.26,0,0,1-.051-.36l.228-.31a.253.253,0,0,1,.356-.054l1.14.856a.286.286,0,0,0,.375-.037l1.608-1.722a.249.249,0,0,1,.357-.013l.277.264a.264.264,0,0,1,.013.366Z"
              transform="translate(-175.782 -194.045)"
              fill={fillColor}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/Protection/ShieldIcon.js